import type { PriceId } from '@iheartjane/types';

import { maybeParseFloat } from './maybeParseFloat';
import type { WeightPriced } from './weightPriced';

/**
 * `0` is a legitimate discounted price (BOGO-free, 100% off). The v1 wire sends
 * it as the string `"0.0"` and the v3 cart as the number `0`, so a truthiness
 * test would accept one and reject the other, silently re-rendering a free line
 * at full price.
 */
const hasPrice = (value: string | number | null | undefined): boolean =>
  value !== null && value !== undefined && value !== '';

export const getActualUnitPrice = (
  menuProduct: WeightPriced,
  priceId: PriceId,
  // Only truthiness-tested, never read, so any special shape serves — but
  // `object` still rejects a primitive passed by mistake.
  applicableSpecial?: object
): number | undefined => {
  const discountedPrice = menuProduct[`discounted_price_${priceId}`];

  return maybeParseFloat(
    applicableSpecial && hasPrice(discountedPrice)
      ? discountedPrice
      : menuProduct[`price_${priceId}`]
  );
};
